import { styled } from '@mui/system'
import { colors, fontSizes } from '../../../../Components/consts'

type StyleProps = {
  backgroundImg: string
}

export const FullVidCon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(6, 1),
  background: colors.darkBackground,
  borderRadius: 6,
  [theme.breakpoints.between('sm', 'md')]: {
    margin: theme.spacing(4, 0),
  },
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(3, 0),
  },
  '& .videoInner': {
    maxWidth: 1080,
  },
}))

export const SingleFullVidCon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(3, 1),
  background: colors.darkBackground,
  borderRadius: 6,
  [theme.breakpoints.between('sm', 'md')]: {
    margin: theme.spacing(2, 0),
  },
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(2, 0),
  },
}))

export const AdditionalVidSection = styled('div')(({ theme }) => ({
  margin: theme.spacing(6, 1),
  [theme.breakpoints.between('sm', 'md')]: {
    margin: theme.spacing(4, 0),
  },
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(3, 0),
  },
}))

export const AdditionalVidCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  cursor: 'pointer',
  margin: theme.spacing(2),
  [theme.breakpoints.between('sm', 'md')]: {
    margin: theme.spacing(2, 1),
  },
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(2, 0),
  },
  '& .infoCon': {
    display: 'flex',
    flexDirection: 'column',
    '& .title': {
      fontSize: fontSizes.medium,
      color: colors.white,
      fontWeight: 'bold',
      [theme.breakpoints.between('sm', 'md')]: {
        fontSize: fontSizes.small,
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.xSmall,
      },
    },
    '& .durationCon': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: theme.spacing(1),
      borderRadius: 12,
      background: colors.lightGrey,
      padding: theme.spacing(0.5, 2),
      maxWidth: 45,
      '& .durationText': {
        fontSize: fontSizes.small,
        color: colors.black,
        fontWeight: 'bold',
        [theme.breakpoints.down('sm')]: {
          fontSize: fontSizes.xSmall,
        },
      },
    },
  },
}))

export const VideoLink = styled('a')(() => ({
  textDecoration: 'none',
  color: colors.text,
}))

export const VideoThumbSmall = styled('div')<StyleProps>(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 8,
  overflow: 'hidden',
  cursor: 'pointer',
  zIndex: 1,
  width: 400,
  marginRight: theme.spacing(2),
  [theme.breakpoints.between('md', 'lg')]: {
    width: 300,
  },
  [theme.breakpoints.between('sm', 'md')]: {
    width: 180,
  },
  [theme.breakpoints.down('sm')]: {
    width: 120,
  },
  '& .imgCon': {
    position: 'absolute',
    top: 0,
    bottom: 0,
    display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
    '& img': {
      height: '100%',
      objectFit: 'cover',
    },
  },
  '& .playBtn': {
    position: 'relative',
    top: '45%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
  },
  '& .durationCon': {
    position: 'relative',
    left: 5,
    bottom: 5,
    borderRadius: 12,
    background: colors.white,
    padding: theme.spacing(0.5, 2),
    '& .durationText': {
      fontSize: fontSizes.small,
      color: colors.black,
      fontWeight: 'bold',
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.xSmall,
      },
    },
  },
}))
